<template>
  <div>
    <!-- <a-spin :spinning="spinning" :indicator="indicator"> -->
    <vxe-toolbar>
      <template #buttons>
        <vxe-input
          v-model="filterName_detable"
          type="search"
          placeholder="Input a key word"
          @keyup="searchEvent_detable"
        ></vxe-input>
        <vxe-button @click="exportDataEvent"
          ><a-icon type="cloud-download" /> Download</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      row-id="id"
      ref="xTable"
      :data="tableData_detable"
      :loading="this.spinning"
      align="center"
      header-align="center"
      class="my-sort"
      :column-config="{ isHover: true }"
      :row-config="{ isCurrent: true, isHover: true }"
      :sort-config="{
        showIcon: false,
        trigger: 'all',
        defaultSort: { field: 'datasetNum', order: 'desc' },
      }"
      @header-cell-click="headerCellClickEvent"
    >
      <!-- 内部展开药物实验详细信息 -->
      <!-- <vxe-column
          type="expand"
          width="40"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message: 'Click to show each experiments',
          }"
        >
          <template #content="{ row }">
            <div class="expand-wrapper" style="margin: 10px 100px">
              <vxe-grid
                :columns="row.childCols"
                :data="row.childData"
              ></vxe-grid>
            </div>
          </template>
        </vxe-column> -->
      <!-- 内部展开药物实验详细信息 -->
      <vxe-column
        field="gene"
        title="Gene name"
        type="html"
        :titlePrefix="{
          icon: 'vxe-icon-question-circle-fill',
          useHTML: true,
          message: 'Click to quickly search for perturbed gene',
        }"
      >
        <template #default="{ row }">
          <a @click="goQS(row.gene)" style="color: blue" target="_blank">{{
            row.gene
          }}</a>
        </template>
      </vxe-column>
      <vxe-column
        field="dataset"
        title="Perturb-Seq ID"
        type="html"
        :titlePrefix="{
          icon: 'vxe-icon-question-circle-fill',
          useHTML: true,
          message: 'Click to view details for perturbed gene in dataset',
        }"
      >
        <template #default="{ row }">
          <div v-if="row.dataset !== null" style="text-align: center">
            <div
              v-for="(index, element) in row.dataset.split(',')"
              :key="index"
              :value="element"
            >
              <a-tag
                onmouseover="this.style.cursor='pointer'"
                color="#4572a7"
                style="margin-bottom: 2px"
                @click="goDS(index, row.gene)"
              >
                {{ index }}</a-tag
              >
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column field="score" title="Prediction score" type="html">
        <template #default="{ row }">
          <div v-if="row.score !== null" style="text-align: center">
            <div
              v-for="(index, element) in row.score.split(',')"
              :key="index"
              :value="element"
            >
              <a-tag color="#2db7f5" style="margin-bottom: 2px">
                {{ index }}</a-tag
              >
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        field="avgscore"
        title="Average prediction score"
        sortable
        type="html"
      >
        <template #header="{ column }">
          <span>{{ column.title }}</span>
          <span class="custom-sort" :class="{ 'is-order': column.order }">
            <i
              :class="[
                column.order
                  ? `vxe-icon-sort-numeric-${column.order}`
                  : 'vxe-icon-sort',
              ]"
            ></i>
          </span>
        </template>
      </vxe-column>
      <vxe-column
        field="datasetNum"
        title="No. of Perturb-Seq datasets"
        type="html"
        sortable
      >
        <template #header="{ column }">
          <span>{{ column.title }}</span>
          <span class="custom-sort" :class="{ 'is-order': column.order }">
            <i
              :class="[
                column.order
                  ? `vxe-icon-sort-numeric-${column.order}`
                  : 'vxe-icon-sort',
              ]"
            ></i>
          </span>
        </template>
      </vxe-column>
      <template #empty>
        <span style="color: grey"> No records found! </span>
      </template>
    </vxe-table>

    <vxe-pager
      background
      size="small"
      :loading="spinning"
      :current-page="tablePage_detable.currentPage"
      :page-size="tablePage_detable.pageSize"
      :total="tablePage_detable.totalResult"
      :page-sizes="[5, 10, 20]"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        // 'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange_table"
    >
    </vxe-pager>
    <!-- </a-spin> -->
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  data() {
    return {
      showresult: true,
      //加载
      spinning: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 5,
        totalResult: 0,
      },
    };
  },

  watch: {
    //如果换了dataset 就晴空数据, 要选到基因才能展示结果
    selectDataset() {
      this.showresult = true;
      this.getdata_detable = null;
      this.tableData_detable = null;
    },
    selectGene() {
      this.showresult = false;
    },
  },
  created() {
    this.spinning = true;
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/drug/drugModel_targetGene.php",
        {
          params: {
            drugid: this.$route.query.drugid,
          },
        }
      )
      .then((response) => {
        this.getdata_detable = response.data.sort(
          (a, b) => b.datasetNum - a.datasetNum
        );
        this.tableData_detable = response.data.sort(
          (a, b) => b.datasetNum - a.datasetNum
        );
        //console.log(response.data);
        this.findList_detable(this.getdata_detable);
        this.spinning = false;
      });
  },

  methods: {
    goQS(value) {
      let routeData = this.$router.resolve({
        name: "quickSearch",
        query: { gene: value },
      });
      window.open(routeData.href, "_blank");
    },
    goDS(value1, value2) {
      let routeData = this.$router.resolve({
        name: "perturbedgenes",
        query: { datasetId: value1, gene: value2 },
      });
      window.open(routeData.href, "_blank");
    },
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "desc") {
          this.spinning = true;
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/drug/drugModel_targetGene.php",
              {
                params: {
                  drugid: this.$route.query.drugid,
                },
              }
            )
            .then((response) => {
              this.getdata_detable = response.data.sort(
                (a, b) => b.datasetNum - a.datasetNum
              );
              this.tableData_detable = response.data.sort(
                (a, b) => b.datasetNum - a.datasetNum
              );
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.spinning = false;
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    goGeneDrug(value) {
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/drugGeneResult?gene=" + value;
      window.open(href, "_blank");
    },
    goToPerturbedgene(value, value2) {
      let routeData = this.$router.resolve({
        name: "perturbedgenes",
        query: { gene: value, datasetId: value2 },
      });
      window.open(routeData.href, "_blank");
    },
    loadContentMethod({ row }) {
      return new Promise((resolve) => {
        setTimeout(() => {
          let childCols = [
            { type: "html", title: "Cell name", field: "cell" },
            { type: "html", title: "Score", field: "score" },
          ];
          // 这个地方只要把一个row的字段传进来就好了
          row.childCols = childCols;
          row.childData = row.subTable;
          resolve();
        }, 200);
      });
    },
    exportDataEvent() {
      const list = this.getdata_detable;
      this.$refs.xTable.exportData({
        filename: this.$route.query.drugid + "_targeted_genes_of_Perturb-seq",
        type: "txt",
        isHeader: true,
        isFooter: true,
        data: list,
      });
    },
    findList_detable(data) {
      this.spinning = true;
      setTimeout(() => {
        const list = data;
        this.spinning = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; //搜索的时候,都爸结果定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["gene", "dataset"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
